import { t } from "i18next"
import React, { useMemo, useState } from "react"
import { Button, Icon, RadioButtons, SelectInput, TextInput } from "components/common"
import { Col, Form, Row } from "antd"
import cx from "clsx"
import { useGetWorkFlowTemplatesQuery } from "../../../../workflows/apis"

function WorkFlowFilters({ filterObject, filterClass, onSearch, workflowCategories }) {
  const [filters, setFilters] = useState(filterObject && { ...filterObject })
  const {
    data: workFlowTemplates,
    isFetching: fetchTemplates,
    isLoading: loadTemplates,
  } = useGetWorkFlowTemplatesQuery()

  const isFilterApplied = useMemo(() => {
    return Object.keys(filterObject).filter(e => !["pageLimit", "page"].find(item => item == e) && !!filterObject[e])
      .length
  }, [filterObject])

  const checkIfFiltersExist = useMemo(() => {
    if (filters?.workflowIds || filters?.leadIds) {
      return isFilterApplied > 0
    }
    return false
  }, [filterObject, filters])

  const handleClear = (filterKey, enableSearch = false) => {
    let obj = { ...filters }
    if (Array.isArray(filterKey)) {
      filterKey.forEach(key => {
        delete obj[key]
      })
      obj = {
        ...obj,
        requestStatus: filters?.requestStatus,
        page: 0,
        pageLimit: 10,
      }
      onSearch(obj)
      setFilters(obj)
      return
    }
    delete obj[filterKey]
    obj = {
      ...obj,
      pageLimit: 10,
    }
    enableSearch ? onSearch(obj) : setFilters(obj)
  }

  return (
    <>
      <Row className={cx("mbe-12 pi-24", filterClass)} align="middle" gutter={[8, 16]}>
        <Col flex="0.5">
          <Form.Item className="mbe-0">
            <TextInput
              key={"leadIds"}
              value={filterObject?.leadIds}
              placeholder={t("Enter Lead Id")}
              handleChange={e => {
                setFilters({ ...filters, leadIds: e.target.value })
              }}
            />
          </Form.Item>
        </Col>
        <Col flex="0.5">
          <Form.Item className="mbe-0">
            <SelectInput
              key={"workflowIds"}
              value={filters?.workflowIds}
              placeholder={t("Select Workflow")}
              showArrow
              options={workFlowTemplates}
              onChange={(value, options) => {
                setFilters({ ...filters, workflowIds: value })
              }}
              allowClear
              onClear={() => handleClear("workflowIds")}
            />
          </Form.Item>
        </Col>

        <Col flex="60px">
          <Button
            type="primary"
            icon={<Icon icon="FiSearch" />}
            text=""
            onClick={() => onSearch(filters)}
            style={{ height: 48 }}
            block
          />
        </Col>

        {checkIfFiltersExist && (
          <Col flex="60px">
            <Button
              type="link"
              danger
              text={t("Reset")}
              onClick={() => {
                handleClear(Object.keys(filters), true)
              }}
            />
          </Col>
        )}
      </Row>

      <Row className="mbe-12 pi-24" justify="space-between" style={{ gap: 8 }}>
        <RadioButtons
          options={workflowCategories}
          value={filterObject?.requestStatus}
          onChange={e => {
            setFilters({ ...filters, requestStatus: e.target.value })
            onSearch({ ...filters, requestStatus: e.target.value })
          }}
          getLabel={item => `${item.title} (${item.count ?? 0})`}
        />
      </Row>
    </>
  )
}

export default WorkFlowFilters
